/** Types */
export const GET_EVENTS_BUSINESS_NONPROFIT_HOME = 'GET_EVENTS_BUSINESS_NONPROFIT_HOME';
export const GET_EVENTS_BUSINESS_NONPROFIT_SUCCESS_HOME = 'GET_EVENTS_BUSINESS_NONPROFIT_SUCCESS_HOME';

